import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useAppSelector } from "../store";

export interface FilterState {
  minMaxValue: { min: number; max: number };
  timeFrame: string;
  filterValue: number[];
  hideCoins: string[];
  treemapCoins: string[] | undefined;
  filteredCoins: string[] | undefined;
}

const initialState: FilterState = {
  timeFrame: "Daily",
  filterValue: [0, Number.MAX_SAFE_INTEGER],
  minMaxValue: { min: 0, max: 0 },
  hideCoins: [],
  treemapCoins: [],
  filteredCoins: [],
};

const TreeMapFilterSlice = createSlice({
  name: "TreeMapFilter",
  initialState,
  reducers: {
    toggleTimeFrame: (state: FilterState, payload: PayloadAction<string>): void => {
      state.timeFrame = payload.payload;
    },
    hideCoin: (state: FilterState, payload: PayloadAction<string[]>): void => {
      state.hideCoins = payload.payload;
    },
    setFilterValue: (state: FilterState, payload: PayloadAction<number[]>): void => {
      state.filterValue = payload.payload;
    },
    setMinMaxValue: (
      state: FilterState,
      payload: PayloadAction<{ min: number; max: number }>,
    ): void => {
      state.minMaxValue = payload.payload;
    },
    setTreemapCoins: (state: FilterState, payload: PayloadAction<string[]>): void => {
      state.treemapCoins = payload.payload;
    },
  },
});

export default TreeMapFilterSlice;
export const useTreeMapFilterState = () => useAppSelector((state) => state.TreeMapFilter);

export const { toggleTimeFrame, hideCoin, setTreemapCoins, setMinMaxValue, setFilterValue } =
  TreeMapFilterSlice.actions;
